import {ResponseStatus} from "../../actions/types";
import {PayloadAction} from "@reduxjs/toolkit";
import {PagingDataModel} from "../../pages/shared/models/paging-data.model";
import {UserAddressesSliceData} from "../slices/user-addresses.slice";

export function handleGetMyAddresses(state: UserAddressesSliceData, status: ResponseStatus, payload: any): void {
    switch (status) {
        case ResponseStatus.PENDING:
            state.isLoading = true;
            state.errors = payload?.errors;

            break;
        case ResponseStatus.FAIL:
            state.isLoading = false;
            state.errors = payload?.errors;

            break;
        case ResponseStatus.SUCCESS:
            state.isLoading = false;

            state.myAddressesData = payload && payload.myAddresses
                ? {...payload.myAddresses}
                : {addresses: [], totalItems: 0, currentPage: 0, pageSize: 11}

            break;
    }
}

export function onPaginationChange (state: UserAddressesSliceData, action: PayloadAction<PagingDataModel>): void {
    state.myAddressesData.pageSize = action.payload.pageSize;
    state.myAddressesData.currentPage = action.payload.currentPage;
}